var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shipment-timeline-container"},[_c('InfiniteTimeline',{attrs:{"items":_vm.items,"display-header":true,"is-loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }